import styled from 'styled-components';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';

export const IconContainer = styled.div`
  width: 15px;
  min-width: 15px;
  flex-shrink: 0;
  align-self: center;
`;

export const StatusBar = styled.span`
  height: 100%;
  width: .1rem;
  border-bottom: .1rem;
  border-top: 1.1rem;
  border-left: .1rem;
  border-right: .1rem;
  border-style: solid;
  border-color: ${props => {
    if(props.iconColor) {
      return props.iconColor;
    }else if(props.status === "negativo" || props.status === "negativo-nulo" || props.status === "triangule-red"){
      return props.theme['color_fire-engine-red'];
    }else if(props.status === "positivo" || props.status === "triangule-green-light"){
      return props.theme.color_green;
    }else if(props.status === "laranja-nulo" || props.status === "triangule-orange"){
      return "#ff7200";
    }else if(props.status === "triangule-yellow"){
      return "#feda32";
    }else if(props.status === "triangule-green-dark"){
      return "#006400";
    }else{
      return props.theme['color_dark-gray'];
    }
  }};
`;

export const ResumeList = styled.ul`
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding-left: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

  &.resume-table--dual {
    @media (max-width: 800px) {
      min-width: 0;

      & > div {
        min-width: 0;
        flex: 1 1 0;
        max-width: 50%;
        box-sizing: border-box;
      }
    }
  }
`;

export const ResumeLi = styled.li`
  display: flex;
  flex-direction: row;
  list-style-type: none;
  color: ${props => props.theme.color_gray};
  padding: .25rem 0;
  margin: .1rem 0;
  font-size: 12px;
  justify-content: start;

  &:nth-last-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  &:not(:hover) {
    background-color: ${({name}) => (name == 'NEGATIVAÇÕES DE CRÉDITO*' || name == 'AÇÕES DE DESPEJO E DE LOCAÇÃO*' || name == 'AÇÕES DE DESPEJO E LOCAÇÃO (Réu)*') && `#ffefcb !important` || (name === 'AÇÕES CRIMINAIS (v. Beta)*' || name === 'AÇÕES CRIMINAIS (Réu)*') && `#673ab736 !important` || (name === 'AÇÕES CÍVEIS (Réu)*' || name === 'Outras AÇÕES do CNJ (Réu)*' || name === 'Outras AÇÕES do CNJ (Autor) (v. Beta)*') && `#79554833 !important` || (name === 'RISCO FC nesta locação' || name === 'RISCO FC em conjunto (nesta locação)') && '#A0B9C7' || (name === 'SCORE FC nesta locação' || name === 'SCORE FC em conjunto (nesta locação)') && '#B0C3D1'};
  }

  &:hover {
    cursor: ${({name}) => (name != 'IRÁ RESIDIR' && name != 'RENDAS INFORMADAS em conjunto' && name != 'ORIGEM Perfil Financeiro ' && name != 'RENDAS PRESUMIDAS em conjunto (Mercado)' && name != 'SCORE FC em conjunto (nesta locação)' && name != 'RISCO DE CRÉDITO em conjunto (Mercado)' && name != 'RISCO FC em conjunto (nesta locação)' && name != 'RISCO de CRÉDITO (Mercado)' && name != 'RISCO FC nesta locação' && name != 'Score de Mercado' && name != 'SCORE FC nesta locação') ? `pointer` : `default`};
    background-color: ${props => {
      if(props.iconColor) {
        return props.iconColor + '2e';
      }
      if(props.status === 'triangule-green-dark') {
        return '#afefa4';
      }
      if(props.status === 'triangule-yellow') {
        return '#ffefcb';
      }
      if(props.status === 'triangule-orange') {
        return '#ffd3be';
      }else if(props.status === "negativo" || props.status === "triangule-red"){
        return props.theme['color_tr-light-red'];
      }else if(props.status === "positivo" || props.status === "triangule-green-light"){
        return props.theme['color_tr-light-green'];
      }else{
        return props.theme['color_tr-light-gray'];
      }
    }} !important;
  }

  @media (max-width: 800px) {
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
`;

export const TextContainer = styled(BaseColumn)`
  display: flex;
  flex-direction: row;
  align-self: center;

  @media (max-width: 800px) {
    width: auto !important;
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
  }
`;

export const ResumeText = styled.div`
  padding: 0 .5rem;
  font-weight: 500;
  font-size: 11px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  box-sizing: border-box;
  font-weight: ${({name}) => (name === 'RISCO FC em conjunto (nesta locação)' || name === 'SCORE FC em conjunto (nesta locação)' || name === 'RISCO FC nesta locação' || name === 'SCORE FC nesta locação') && '700'};

  @media (max-width: 800px) {
    flex-wrap: wrap;
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;
